export enum AuthContextEnum {
  'signup' = 1,
  'login',
  'connectProfile',
  'reconnectProfile',
  'connectCompany',
  'connectBusiness',
  'connectPage',
  'connectGroup',
  'toggleDirectPublishing',
  'getExternalId',
  'changeWhoPosts'
}
